import React from "react";
import DynamicForm from "../../components/AdvanceDynamicCreate/DynamicForm";
import { getStoredData } from "../../json/fecthData";

const BillingReciptCreate = () => {
  // Fetch stored Billing data
  const BillingData = getStoredData()?.[1] || {}; // Adjust index if needed

  return (
    <div>
      <h2>Create New {BillingData.TitleBilling}</h2>
      <DynamicForm
        fields={BillingData.AdminBilling} // Pass dynamic fields
        apiUrl={BillingData.ApiBilling} // Use correct API URL
        successRedirect={BillingData.RedirectAdminBilling} // Redirect after submission
      />
    </div>
  );
};

export default BillingReciptCreate;